import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: var(--border-box);

  &:empty {
    display: none;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const BorderedSection = styled.section`
  border: var(--border-box);
  border-radius: var(--border-box-radius);
  padding: 20px;
  margin: 0 -20px 20px;
`;

const SectionNoBorder = styled(Section)`
  padding-bottom: 0;
  border-bottom: none;
`;

const HugeBlock = styled.div`
  margin-top: 40px;

  &:first-child {
    margin-top: 0;
  }
`;

const BigBlock = styled.div`
  margin-top: 20px;

  &:first-child {
    margin-top: 0;
  }
`;

const Block = styled.div`
  margin-top: 10px;

  &:first-child {
    margin-top: 0;
  }
`;

const SmallBlock = styled.div`
  margin-top: 5px;

  &:first-child {
    margin-top: 0;
  }
`;

export const SmallBlocks: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>
    {React.Children.toArray(children).map((child, index) => <SmallBlock key={index}>{child}</SmallBlock>)}
  </>
);

export {
  Section, BorderedSection, SectionNoBorder, HugeBlock, BigBlock, SmallBlock, Block,
};
